module.exports = __webpack_public_path__ + "images/emoji/christmas_tree.95a208f10aacef503a0c.png";